import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
}
export function Section({
  children,
  className = '',
  id
}: SectionProps) {
  return <motion.section id={id} className={className} initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.7,
    ease: 'easeOut'
  }} data-id="element-242">
      {children}
    </motion.section>;
}